import GenerateEnum from '../generateEnum'
import { getLabelText } from '../utils'

/**
 * 欧代敏感词风险程度
 * 0: 高风险
 * 1: 中风险
 */
export const OUDAI_SENSITIVE_WORD_RISK_LEVEL = new GenerateEnum({
  HIGH: {
    value: 0,
    label: getLabelText({ key: 'remote.admin.highRisk', text: '高风险' })
  },
  MEDIUM: {
    value: 1,
    label: getLabelText({ key: 'remote.admin.mediumRisk', text: '中风险' })
  }
})



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/enum/oudaiVerification.js